// Multi-Event packet members. A project-backed member is { projectId }. An EPS
// row with no Project ID joins as an EPS-only event, { epsOnly, key, … }: the
// key is used only inside its packet, and the packet keeps its own copy of the
// row's schedule (taken when it is added). Project-ID features skip it.

import { newId } from './rosActivity';

/** What a picker row is selected by: its Project ID, or (EPS-only) its row as listed now. */
export function pickKey(c) {
  return c.projectId || `row:${c.rowNumber}@${c.loadInISO || ''}`;
}

/** A selected member's key in the packet: its Project ID, or its EPS-only key. */
export function memberKey(m) {
  return m && m.epsOnly ? m.key : m && m.projectId;
}

/** The members that are projects (have a Project ID). */
export function projectMemberIds(selectedMembers) {
  return (selectedMembers || []).filter((m) => m && !m.epsOnly && m.projectId).map((m) => m.projectId);
}

/** A new EPS-only member from its picker row; the server reads the row's schedule when it is saved. */
export function epsOnlyMember(c) {
  return { epsOnly: true, key: `eps-${newId().replace(/[^A-Za-z0-9]/g, '').slice(0, 12)}`, rowNumber: c.rowNumber, loadInISO: c.loadInISO || '', title: c.title };
}
